import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SupportGuardProps {
  children: React.ReactNode;
}

export function SupportGuard({ children }: SupportGuardProps) {
  const navigate = useNavigate();
  const { authUser, isSupportUser, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!authUser) {
        navigate('/admin', { replace: true });
      } else if (!isSupportUser) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [authUser, isSupportUser, loading, navigate]);

  if (loading || !authUser || !isSupportUser) {
    return null;
  }

  return <>{children}</>;
}
